(() => {
  'use strict';
  if (window.vwdFilterGuidanceStarted) return;
  window.vwdFilterGuidanceStarted = true;

  const sortDescriptions = {
    relevance: 'Best Match uses the search engine’s relevance order. Check each window’s features to confirm it meets your needs.',
    collection_sort: 'Featured uses the collection’s featured product order.',
    title: 'Name, A–Z sorts product names alphabetically.',
    'title:desc': 'Name, Z–A sorts product names in reverse alphabetical order.',
    price: 'Price, Low to High puts lower-priced products first.',
    'price:desc': 'Price, High to Low puts higher-priced products first.',
    published_at: 'Date, Old to New puts older product listings first. This is the listing date, not the window’s manufacture date.',
    'published_at:desc': 'Date, New to Old puts newer product listings first. This is the listing date, not the window’s manufacture date.'
  };
  let scheduled = false;
  let guideOpen = false;
  let nextId = 0;

  function describe(control, id) {
    const ids = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (!ids.includes(id)) control.setAttribute('aria-describedby', [...ids, id].join(' '));
  }

  function update() {
    scheduled = false;
    const configNode = document.getElementById('vwd-audit-labels');
    const labels = configNode ? JSON.parse(configNode.textContent) : null;
    document.querySelectorAll('.cm_total-hits span').forEach(node => {
      if (node.textContent.trim() === '1 results' && labels) node.textContent = labels.one;
    });
    if (labels?.dealer) document.querySelectorAll('.cm_SearchResult .price, .cm_SearchBox .price').forEach(price => {
      if (price.querySelector('[data-vwd-retail-reference], .vwd-retail-reference')) return;
      const label = document.createElement('small');
      label.dataset.vwdRetailReference = '';
      label.textContent = labels.retail;
      label.title = labels.help;
      label.style.cssText = 'display:block;font-size:12px;font-weight:400;line-height:1.5';
      price.prepend(label);
    });
    document.querySelectorAll('.cm_FacetPanel').forEach(panel => {
      const best = panel.querySelector('.cm_field-custom_best_use_filter');
      if (!best) return;
      const positions = [...panel.querySelectorAll('.cm_field-custom_direct_fit_position_filter,.cm_field-custom_universal_side_filter')]
        .filter(position => position.parentElement === best.parentElement);
      const position = positions[positions.length - 1];
      if (position && position.nextElementSibling !== best) position.after(best);
    });
    document.querySelectorAll('.cm_field-stock .facetentrykey').forEach(option => {
      if (option.textContent.trim() === 'Available') option.textContent = 'In stock + preorders';
    });
    document.querySelectorAll('.cm_field-stock .facetbody').forEach(body => {
      if (body.querySelector('[data-vwd-stock-help]')) return;
      const note = document.createElement('p');
      note.className = 'vwd-best-for-help';
      note.setAttribute('data-vwd-stock-help', '');
      note.textContent = 'Choose In-stock Only to exclude preorders. Preorder items show their own availability estimate.';
      body.prepend(note);
    });
    document.querySelectorAll('.cm_field-custom_best_use_filter .facetbody').forEach(body => {
      if (!body.querySelector('[data-vwd-best-for-help]')) {
        const note = document.createElement('p');
        note.className = 'vwd-best-for-help';
        note.setAttribute('data-vwd-best-for-help', '');
        note.id = 'vwd-best-for-help-' + (++nextId);
        note.textContent = 'Choose one or more. Results match any selected need, not necessarily all. Adding options can show more windows.';
        body.prepend(note);
      }
      const note = body.querySelector('[data-vwd-best-for-help]');
      body.querySelectorAll('.facetentrykey').forEach(option => describe(option, note.id));
    });

    document.querySelectorAll('.cm_SearchHeader').forEach(header => {
      const select = header.querySelector('.cm_sort-select');
      if (!select) return;
      let guide = header.querySelector('[data-vwd-filter-guide]');
      if (!guide) {
        guide = document.createElement('details');
        guide.className = 'vwd-filter-guide';
        guide.setAttribute('data-vwd-filter-guide', '');
        guide.open = guideOpen;
        guide.innerHTML = '<summary>How filters &amp; sorting work</summary>' +
          '<div class="vwd-filter-guide__content">' +
          '<p><strong>Multiple selections:</strong> In a filter that allows multiple choices, results can match any selected option. For example, choosing Driving ventilation and Rain &amp; snow ventilation shows windows suited to either need; each window may not offer both. Add a different filter, such as window position, to narrow your choices.</p>' +
          '<p><strong>Sorting:</strong> Sort by changes the order of your current results. It does not add a requirement that windows meet every selected “Best for” need.</p>' +
          '<p class="vwd-filter-guide__sort" data-vwd-sort-help></p>' +
          '</div>';
        guide.querySelector('[data-vwd-sort-help]').id = 'vwd-sort-help-' + (++nextId);
        header.appendChild(guide);
      }
      const help = guide.querySelector('[data-vwd-sort-help]');
      const text = sortDescriptions[select.value] || 'Choose a sorting option to change the order of your current results.';
      if (help.textContent !== text) help.textContent = text;
      describe(select, help.id);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }
  document.addEventListener('change', event => {
    if (event.target.matches('.cm_sort-select')) schedule();
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches('[data-vwd-filter-guide]')) guideOpen = event.target.open;
  }, true);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', schedule);
  update();
})();

